import React, { useState ,useEffect} from "react";
import ReactSelect from 'react-select'; 
// Import react-select
import Stepper from 'react-stepper-horizontal'; // Import Stepper

import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Heading,
  VStack,
  Grid,
  GridItem,
  useToast,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Checkbox,
  Select,
  Flex,
  CloseButton,
  Text,
  Tag,
  TagLabel,
  TagCloseButton,
  HStack,
  InputGroup,
  InputLeftElement,
} from "@chakra-ui/react";
import { CheckCircleIcon, WarningIcon } from "@chakra-ui/icons";
import { ChevronDownIcon } from "@chakra-ui/icons";
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

function CreateJobForm({ onClose }) {
  const [formData, setFormData] = useState({
    jobTitle: '',
    jobStartDate: '',
    jobEndDate: '',
    startTime: '',
    endTime: '',
    currencyType: 'GBP',
    salary: '',
    salaryUnit: '',
    country: '',
    address: '',
    postalCode: '',
    region: '',
    vacancies: '',
    settlementPeriod: '',
    description: '',
    mandatorySkills: [],
    otherSkills: []
  });
  const toast = useToast();
  const toastIdRef = React.useRef();
  const navigate = useNavigate();
   const [skillsOptions, setSkillsOptions] = useState([]);
   const [countryOptions, setCountryOptions] = useState([]);
   const [currentStep, setCurrentStep] = useState(1);
   const [region, setRegion] = useState('');
   const [postalCodeError, setPostalCodeError] = useState('');

  useEffect(() => {
    const fetchSkills = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/provider/getNewSpecializationPool`);
        if (response.status === 200) {
          const skillsData = response.data.data;
          console.log(skillsData);
          setSkillsOptions(skillsData);
        }
      } catch (error) {
        console.error("Error fetching skills:", error);
      }
    };

    fetchSkills();
  }, []);

  const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format

  // Fetch countries on component mount
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/globalrouter/get-countries`);
        console.log(response.data);
        if (response.status === 200 && Array.isArray(response.data.data)) {
          const countries = response.data.data.map((country) => ({
            value: country.iso2,
            label: country.name,
          }));
          console.log("Fetched countries:", countries);
          setCountryOptions(countries);
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);

  const handlePostalCodeChange = async (e) => {
    const { value } = e.target;
    setFormData({ ...formData, postalCode: value });
    
    if (value.trim()) {
      try {
        // Check if the country is UK or India and use appropriate API
        if (formData.country?.iso2 === 'GB') {
          // UK postal code API
          const response = await axios.get(`https://api.postcodes.io/postcodes/${value}`);
          
          if (response.status === 200 && response.data && response.data.result) {
            const regionValue = response.data.result.region || 'Region not found';
            setRegion(regionValue);
            setFormData((prevFormData) => ({
              ...prevFormData,
              region: regionValue // Update formData with the region
            }));
            setPostalCodeError(''); // Clear any previous error
          } else {
            setRegion('');
            setPostalCodeError('Invalid postal code or region not found');
          }
        } else if (formData.country?.iso2 === 'IN') {
          // India postal code API
          const response = await axios.get(`https://api.postalpincode.in/pincode/${value}`);
          
          if (response.status === 200 && response.data && response.data[0].Status === "Success") {
            const postOffice = response.data[0].PostOffice[0];
            const regionValue = `${postOffice.District}, ${postOffice.State}`;
            setRegion(regionValue);
            setFormData((prevFormData) => ({
              ...prevFormData,
              region: regionValue
            }));
            setPostalCodeError('');
          } else {
            setRegion('');
            setPostalCodeError('Invalid PIN code or region not found');
          }
        } else {
          setRegion('');
          setPostalCodeError('Please select a country first');
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setRegion('');
          setPostalCodeError('Postal code not found. Please enter a valid postal code.');
        } else {
          setRegion('');
          setPostalCodeError('Failed to fetch region. Please try again later.');
          console.error("Error fetching region:", error);
        }
      }
    } else {
      setRegion('');
      setPostalCodeError(''); // Clear region and error if postal code is empty
    }
  };
  


  const handleNext = () => {
    if (currentStep < 4) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrevious = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };
 
  
  const handleCountryChange = (selectedOption) => {
    console.log("Selected Country:", selectedOption); // Debug log to verify selected option
    setFormData((prevState) => ({
      ...prevState,
      country: {
        iso2: selectedOption ? selectedOption.value : '',
        name: selectedOption ? selectedOption.label : '',
      },
    }));
  };
  
  const handleMandatorySkillsChange = (selectedOptions) => {
    const skills = selectedOptions ? selectedOptions.map(option => option.value) : [];
    setFormData({ ...formData, mandatorySkills: skills });
  };

  const handleOtherSkillsChange = (selectedOptions) => {
    const skills = selectedOptions ? selectedOptions.map(option => option.value) : [];
    setFormData({ ...formData, otherSkills: skills });
  };

  // Filter options for each select component
  const filteredMandatorySkillsOptions = skillsOptions.filter(
    skill => !formData.otherSkills.includes(skill.name)
  );

  const filteredOtherSkillsOptions = skillsOptions.filter(
    skill => !formData.mandatorySkills.includes(skill.name)
  );

  const handleSubmit = async () => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    // console.log('Retrieved token:', ticketToken);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/provider/post-job`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${ticketToken}`
          }
        }
      );
      if (response.status === 200) {

      if (!toast.isActive(toastIdRef.current)) {
        toastIdRef.current = toast({
          position: "top",
          duration: 3000,
          isClosable: true,
          render: () => (
            <Box color="white" p={3} bg="green.500" borderRadius="md" display="flex" alignItems="center">
              <CheckCircleIcon mr={2} />
              Job posted successfully!
            </Box>
          ),
        });
      }
      onClose(); // Close the modal after successful submission

      navigate(-1); // Navigate back to the previous page
    } 
  }catch (error) {
      if (!toast.isActive(toastIdRef.current)) {
        toastIdRef.current = toast({
          position: "top",
          duration: 3000,
          isClosable: true,
          render: () => (
            <Box color="white" p={3} bg="red.500" borderRadius="md" display="flex" alignItems="center">
              <WarningIcon mr={2} />
              Failed to post job. Please try again.<br/>
              Please verify all required fields are filled.
            </Box>
          ),
        });
      }
    }
  };

  const handleCancel = () => {
    onClose(); // Call the onClose method to close the modal on cancel
  };
 
  return (
    <Box width="100%" mx="auto" p={[4, 6]} boxShadow="lg" borderRadius="md" bg="white" mt={-4}>
    {/* Step Indicator */}
    <Stepper 
      steps={[{ title: "Job Information" }, { title: "Salary & Expertise Details" }, { title: "Location Details" }, { title: "Review & Submit" }]}
      activeStep={currentStep - 1}
      activeColor="#3b82f6"
      completeColor="#3b82f6"
      defaultColor="#ccc"
      size={32}
      circleFontSize={16}
    />
<Box mt={6} />
      <Box minHeight="450px"> {/* Ensures consistent height for all steps */}
        <VStack spacing={[4, 6]} align="stretch">
          {currentStep === 1 && (
      <Grid templateColumns={["1fr", "repeat(2, 1fr)"]} columnGap={6} rowGap={8} width="100%">
        <GridItem colSpan={[1, 2]}>
          <FormLabel>Job Title<span style={{ color: 'red' }}> *</span></FormLabel>
          <FormControl isRequired>
            <Input id="jobTitle" type="text" placeholder="Enter job title" value={formData.jobTitle} onChange={handleChange} />
          </FormControl>
        </GridItem>
        <GridItem colSpan={[1, 1]}>
          <FormLabel>Job Start Date<span style={{ color: 'red' }}> *</span></FormLabel>
          <FormControl isRequired>
            <Input id="jobStartDate" type="date" value={formData.jobStartDate} onChange={handleChange} min={today} />
          </FormControl>
        </GridItem>
        <GridItem colSpan={[1, 1]}>
          <FormLabel>Job End Date<span style={{ color: 'red' }}> *</span></FormLabel>
          <FormControl isRequired>
            <Input id="jobEndDate" type="date" value={formData.jobEndDate} onChange={handleChange} min={formData.jobStartDate || today} />
          </FormControl>
        </GridItem>
        <GridItem colSpan={[1, 1]}>
          <FormLabel>Start Time<span style={{ color: 'red' }}> *</span></FormLabel>
          <FormControl isRequired>
            <Input id="startTime" type="time" value={formData.startTime} onChange={handleChange} />
          </FormControl>
        </GridItem>
        <GridItem colSpan={[1, 1]}>
          <FormLabel>End Time<span style={{ color: 'red' }}> *</span></FormLabel>
          <FormControl isRequired>
            <Input id="endTime" type="time" value={formData.endTime} onChange={handleChange} />
          </FormControl>
        </GridItem>
      </Grid>
  )}

{currentStep === 2 && (
  <Grid templateColumns={["1fr", "repeat(2, 1fr)"]} columnGap={6} rowGap={4} width="100%">
    <GridItem colSpan={[1, 1]}>
      <FormLabel>Salary<span style={{ color: 'red' }}> *</span></FormLabel>
      <FormControl isRequired>
        <InputGroup>
          <InputLeftElement width="5rem">
            <Select
              id="currencyType"
              value={formData.currencyType}
              onChange={handleChange}
              bg="gray.100"
              color="black"
              borderColor="gray.500"
              height="40px"
              width="100%"
              borderRadius="0"
            >
              <option value="GBP">GBP</option>
              <option value="INR">INR</option>
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
            </Select>
          </InputLeftElement>
          <Input
            id="salary"
            type="number"
            placeholder="Enter salary"
            value={formData.salary}
            onChange={handleChange}
            borderColor="gray.400"
            focusBorderColor="#1A75E8"
            _hover={{ borderColor: "gray.400" }}
            pl="5rem"
          />
        </InputGroup>
      </FormControl>
    </GridItem>

    <GridItem colSpan={[1, 1]}>
      <FormLabel>Salary Unit<span style={{ color: 'red' }}> *</span></FormLabel>
      <FormControl isRequired>
        <Select
          id="salaryUnit"
          placeholder="Select unit"
          value={formData.salaryUnit}
          onChange={handleChange}
          borderColor="gray.400"
          focusBorderColor="#1A75E8"
          _hover={{ borderColor: "gray.400" }}
        >
          <option value="/hr">Per Hour</option>
          <option value="/day">Per Day</option>
          <option value="/week">Per Week</option>
          <option value="/month">Per Month</option>
          <option value="/year">Per Year</option>
        </Select>
      </FormControl>
    </GridItem>

    <GridItem colSpan={[1, 1]}>
      <FormLabel>Mandatory Skills<span style={{ color: 'red' }}> *</span></FormLabel>
      <FormControl isRequired>
        <ReactSelect
          isMulti
          name="mandatorySkills"
          options={filteredMandatorySkillsOptions.map(skill => ({
            value: skill.name,
            label: skill.name
          }))}
          className="basic-multi-select"
          classNamePrefix="select"
          value={filteredMandatorySkillsOptions
            .filter(option => formData.mandatorySkills.includes(option.name))
            .map(option => ({ value: option.name, label: option.name }))}
          onChange={handleMandatorySkillsChange}
        />
      </FormControl>
    </GridItem>
    <GridItem colSpan={[1, 1]}>
      <FormLabel>Other Skills</FormLabel>
      <FormControl>
        <ReactSelect
          isMulti
          name="otherSkills"
          options={filteredOtherSkillsOptions.map(skill => ({
            value: skill.name,
            label: skill.name
          }))}
          className="basic-multi-select"
          classNamePrefix="select"
          value={filteredOtherSkillsOptions
            .filter(option => formData.otherSkills.includes(option.name))
            .map(option => ({ value: option.name, label: option.name }))}
          onChange={handleOtherSkillsChange}
        />
      </FormControl>
    </GridItem>

    <GridItem colSpan={[1, 1]}>
      <FormLabel>Vacancies<span style={{ color: 'red' }}> *</span></FormLabel>
      <FormControl isRequired>
        <Input id="vacancies" type="number" placeholder="Enter number of vacancies" value={formData.vacancies} onChange={handleChange} />
      </FormControl>
    </GridItem>
    <GridItem colSpan={[1, 1]}>
      <FormLabel>Payment Period<span style={{ color: 'red' }}> *</span></FormLabel>
      <FormControl isRequired>
        <Select
          id="settlementPeriod"
          placeholder="Select settlement period"
          value={formData.settlementPeriod}
          onChange={handleChange}
        >
          <option value="7 days">within 7 days</option>
          <option value="15 days">within 15 days</option>
          <option value="30 days">within 30 days</option>
          <option value="month-end">at month-end</option>
        </Select>
      </FormControl>
    </GridItem>

    <GridItem colSpan={[1, 2]}>
      <FormLabel>Job Description<span style={{ color: 'red' }}> *</span></FormLabel>
      <FormControl isRequired>
        <Textarea
          id="description"
          placeholder="Enter job description"
          value={formData.description}
          onChange={(e) => handleChange(e)}
          borderColor="gray.400"
          focusBorderColor="#1A75E8"
          _hover={{ borderColor: "gray.400" }}
          height="80px"
        />
      </FormControl>
    </GridItem>
  </Grid>
)}

{currentStep === 3 && (
  <Grid templateColumns={["1fr", "repeat(2, 1fr)"]} columnGap={6} rowGap={8} width="100%">
    <GridItem colSpan={[1, 2]}>
      <FormLabel>Country<span style={{ color: 'red' }}> *</span></FormLabel>
      <FormControl isRequired>
        <ReactSelect
          id="country"
          placeholder="Select country"
          value={countryOptions.find(option => option.value === formData.country?.iso2) || null}
          onChange={handleCountryChange}
          options={countryOptions}
        />
      </FormControl>
    </GridItem>
    <GridItem colSpan={[1, 2]}>
      <FormLabel>Address<span style={{ color: 'red' }}> *</span></FormLabel>
      <FormControl isRequired>
      <Textarea
  id="address"
  placeholder="Enter full address"
  value={formData.address}
  onChange={handleChange}
  borderColor="gray.400"
  focusBorderColor="#1A75E8"
  _hover={{ borderColor: "gray.400" }}
  height="100px" // Adjust height as needed
  resize="vertical" // Allow vertical resizing
/>
</FormControl>
    </GridItem>
    <GridItem colSpan={[1, 2]}>
      <FormLabel>Postal Code<span style={{ color: 'red' }}> *</span></FormLabel>
      <FormControl isRequired>
        <Input id="postalCode" type="text" placeholder="Enter postal code" value={formData.postalCode} onChange={handlePostalCodeChange} />
        {region && <Text mt={2} color="green.500">Region: {region}</Text>}
        {postalCodeError && <Text mt={2} color="red.500">{postalCodeError}</Text>}
      </FormControl>
    </GridItem>
  </Grid>
)}

{currentStep === 4 && (
  <Box height="450px" overflowY="auto"> {/* Ensures consistent height */}
    <Heading as="h3" size="md" mb={4}>Review Your Details</Heading>
    
    <Grid templateColumns={["1fr", "repeat(2, 1fr)"]} columnGap={6} rowGap={1}>
      <GridItem>
        <Box mb={4}><strong>Job Title:</strong> {formData.jobTitle}</Box>
      </GridItem>

      <GridItem>
        <Box mb={4}><strong>Salary:</strong> {formData.currencyType} {formData.salary} {formData.salaryUnit}</Box>
      </GridItem>

      <GridItem>
        <Box mb={4}><strong>Start Date:</strong> {formData.jobStartDate}</Box>
      </GridItem>

      <GridItem>
        <Box mb={4}><strong>End Date:</strong> {formData.jobEndDate}</Box>
      </GridItem>

      <GridItem>
        <Box mb={4}><strong>Start Time:</strong> {formData.startTime}</Box>
      </GridItem>

      <GridItem>
        <Box mb={4}><strong>End Time:</strong> {formData.endTime}</Box>
      </GridItem>
    </Grid>

    <Box mb={4}><strong>Mandatory Skills:</strong> {formData.mandatorySkills.join(', ')}</Box>
    <Box mb={4}><strong>Other Skills:</strong> {formData.otherSkills.join(', ')}</Box>
    <Box mb={4}><strong>Vacancies:</strong> {formData.vacancies}</Box>
    <Box mb={4}><strong>Payment Period:</strong> within {formData.settlementPeriod} </Box>
    <Box mb={4}><strong>Description:</strong> {formData.description}</Box>
    <Box mb={4}><strong>Country:</strong> {formData.country.name || ''}</Box>
    <Box mb={4}><strong>Address:</strong> {formData.address}</Box>
    {/* Postal Code and Region in the same row */}
    <Grid templateColumns="repeat(2, 1fr)" columnGap={6} mb={4}>
        <GridItem>
          <Box><strong>Postal Code:</strong> {formData.postalCode}</Box>
        </GridItem>
        {region && (
          <GridItem>
            <Box><strong>Region:</strong> {region}</Box>
          </GridItem>
        )}
      </Grid>
  </Box>
)}

        </VStack>
      </Box>
       <CloseButton
        size="lg"
        onClick={onClose}
        position="absolute"
        color="blue.500"
        _hover={{ bg: "blue.500", color: "white" }}
        top="-10px"
        right="10px"
        zIndex="1"
      />
      <Grid templateColumns="1fr" justifyContent="flex-end" width="100%">
  <Box display="flex" justifyContent="flex-end" gap={4}>
    {currentStep > 1 && (
      <Button
        variant="outline"
        color="gray.500"
        borderColor="gray.500"
        _hover={{ bg: "gray.200" }}
        width="150px" // Ensuring the same width for all buttons
        onClick={handlePrevious}
      >
        Previous
      </Button>
    )}
    <Button
      colorScheme="blue"
      bg="blue.500"
      _hover={{ bg: "blue.600" }}
      width="150px" // Ensuring the same width for all buttons
      onClick={currentStep < 4 ? handleNext : handleSubmit}
    >
      {currentStep < 4 ? 'Next' : 'Submit'}
    </Button>
  </Box>
</Grid>


    </Box>
  );
}



export default CreateJobForm;